export const domain = "https://api-sb.mooo.com";
// export const domain = "http://localhost:4000";
